import { userConstants } from '../constants';

const initialState = {
  loading: false,
  avatars: [],
  items: [],
  error: null,
};

export function users(state = initialState, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.users,
        error: null,
      };
    case userConstants.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case userConstants.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        items: Array.isArray(state.items)
          ? state.items.map(user =>
              user.id === action.id
                ? { ...user, deleting: true }
                : user
            )
          : (state.items || []),
      };
    case userConstants.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        ...state,
        items: Array.isArray(state.items)
          ? state.items.filter(user => user.id !== action.id)
          : [],
      };
    case userConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user
      return {
        ...state,
        items: Array.isArray(state.items)
          ? state.items.map(user => {
              if (user.id === action.id) {
                // make copy of user without 'deleting:true' property
                const { deleting, ...userCopy } = user;
                // return copy of user with 'deleteError:[error]' property
                return { ...userCopy, deleteError: action.error };
              }

              return user;
            })
          : (state.items || []),
      };
    case userConstants.FETCH_AVATARS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case userConstants.FETCH_AVATARS_SUCCESS:
      return {
        ...state,
        loading: false,
        avatars: action.avatars,
        error: null,
      };
    case userConstants.FETCH_AVATARS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state
  }
}
